<template>
  <div v-if="title" class="headline-action">
    <Component
      :is="linkBtn ? 'nuxt-link' : 'div'"
      :to="linkBtn"
      class="headline-action__head-link"
    >
      <div v-if="img" class="headline-action__img-wrapper">
        <img
          v-lazy="img"
          class="headline-action__img"
          :src="$pixel"
          :alt="title"
          width="42"
          height="26"
        />
      </div>

      <UiText
        v-if="title"
        class="headline-action__head-title"
        font="components-section-title"
        color="typography-title01"
        :text="title"
      />
    </Component>

    <slot />
  </div>
</template>

<script>
export default {
  name: 'HeadlineAction',
  props: {
    title: { type: String },
    linkBtn: { type: String },
    img: { type: String },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
